var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u7EC4_1",
    "data-name": "\\u7EC4 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 26,
    viewBox: "0 0 158 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4779d0;\n        filter: url(#filter);\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-7 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #31506e;\n      }\n\n      .cls-5 {\n        fill: #ffe3b3;\n      }\n\n      .cls-6 {\n        fill: #f7805c;\n      }\n\n      .cls-7 {\n        fill: #5898d7;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIyMy45MDgiIHkxPSIyNiIgeDI9IjIuMDkyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzBjMjQ0MiIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM0Zjc0OTIiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjI2IiBoZWlnaHQ9IjI2Ii8+Cjwvc3ZnPgo="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_9_\\u62F7\\u8D1D_2",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 9 \\u62F7\\u8D1D 2",
    className: "cls-1",
    width: 26,
    height: 26,
    rx: 5.078,
    ry: 5.078
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_4",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 4",
    className: "cls-2",
    d: "M4.212,3.729h0a0.554,0.554,0,0,1,.754.209L7.143,7.787a0.552,0.552,0,0,1-.21.753h0a0.554,0.554,0,0,1-.754-0.209L4,4.482A0.552,0.552,0,0,1,4.212,3.729Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_4_\\u62F7\\u8D1D",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 4 \\u62F7\\u8D1D",
    className: "cls-2",
    d: "M9.161,3.81h0a0.561,0.561,0,0,0-.762.21L6.2,7.887a0.553,0.553,0,0,0,.212.756h0a0.561,0.561,0,0,0,.762-0.21l2.2-3.867A0.553,0.553,0,0,0,9.161,3.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_1",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 1",
    className: "cls-3",
    d: "M4.469,7.188h14.7a3.047,3.047,0,0,1,3.047,3.047V19.3a3.047,3.047,0,0,1-3.047,3.047H4.469a2.031,2.031,0,0,1-2.031-2.031V9.219A2.031,2.031,0,0,1,4.469,7.188Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_2",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 2",
    className: "cls-4",
    d: "M5.575,8.345H16.082a2.031,2.031,0,0,1,2.031,2.031v8.647a2.031,2.031,0,0,1-2.031,2.031H5.575a2.031,2.031,0,0,1-2.031-2.031V10.376A2.031,2.031,0,0,1,5.575,8.345Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_3",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 3",
    className: "cls-2",
    d: "M8.248,12.582H8.614A1.016,1.016,0,0,1,9.63,13.6v3.495a1.016,1.016,0,0,1-1.016,1.016H8.248a1.016,1.016,0,0,1-1.016-1.016V13.6A1.016,1.016,0,0,1,8.248,12.582Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_3_\\u62F7\\u8D1D",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 3 \\u62F7\\u8D1D",
    className: "cls-2",
    d: "M14.7,12.582h0.366A1.016,1.016,0,0,1,16.084,13.6v3.495a1.016,1.016,0,0,1-1.016,1.016H14.7a1.016,1.016,0,0,1-1.016-1.016V13.6A1.016,1.016,0,0,1,14.7,12.582Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_5",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 5",
    className: "cls-5",
    d: "M20.6,10.187h1.842A1.016,1.016,0,0,1,23.461,11.2v7.178A1.016,1.016,0,0,1,22.445,19.4H20.6a1.016,1.016,0,0,1-1.016-1.016V11.2A1.016,1.016,0,0,1,20.6,10.187Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_1",
    "data-name": "\\u692D\\u5706 1",
    className: "cls-6",
    cx: 21.516,
    cy: 12.672,
    r: 1.016
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_1_\\u62F7\\u8D1D",
    "data-name": "\\u692D\\u5706 1 \\u62F7\\u8D1D",
    className: "cls-6",
    cx: 21.516,
    cy: 15.297,
    r: 1.016
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "PopupJoyland",
    className: "cls-7",
    d: "M34.7,14.974h5.664V6.318a0.985,0.985,0,0,0-.288-0.712,0.945,0.945,0,0,0-.7-0.3H31.164V19.934H34.7v-4.96Zm0-8.608h1.968A0.3,0.3,0,0,1,37,6.7v7.2H34.7V6.366Zm16.368,4.5a0.985,0.985,0,0,0-.288-0.712,0.945,0.945,0,0,0-.7-0.3h-8.24v10.08h9.232V10.862Zm-4.048.176a0.3,0.3,0,0,1,.336.336v7.392H45.692V11.038H47.02ZM52.54,23.47h3.888v-4.3h5.5v-8.3a0.985,0.985,0,0,0-.288-0.712,0.945,0.945,0,0,0-.7-0.3h-8.4V23.47Zm3.888-12.432H58.06a0.3,0.3,0,0,1,.336.336v6.592H56.428V11.038Zm6.976,8.9h5.712l1.7-.512,1.7,0.512h1.2V18.782h-1.2V9.934H68.715v8.848H67.2V9.934H63.4v10ZM75.179,23.47h3.888v-4.3h5.5v-8.3a0.985,0.985,0,0,0-.288-0.712,0.945,0.945,0,0,0-.7-0.3h-8.4V23.47Zm3.888-12.432H80.7a0.3,0.3,0,0,1,.336.336v6.592H79.067V11.038Zm9.952,7.792H86.043v1.1h6.4V5.294H89.019V18.83Zm14.128-7.968a0.985,0.985,0,0,0-.288-0.712,0.945,0.945,0,0,0-.7-0.3h-8.24v10.08h9.232V10.862Zm-4.048.176a0.3,0.3,0,0,1,.336.336v7.392H97.771V11.038H99.1Zm16.016-1.184L110.459,23.47h-3.792l1.648-4.672h-0.736l-2.96-8.944h3.472l1.664,4.864,1.712-4.864h3.648Zm5.487-4.72h-4.016v14.8H120.6V5.134ZM132.378,18.75h-1.2V10.782a0.985,0.985,0,0,0-.288-0.712,0.945,0.945,0,0,0-.7-0.3h-8.112v10.16h5.712l1.7-.672,1.7,0.672h1.2V18.75Zm-5.248-7.792a0.3,0.3,0,0,1,.336.336V18.75h-1.68V10.958h1.344Zm16.048,8.976v-8.88a0.985,0.985,0,0,0-.288-0.712,0.946,0.946,0,0,0-.7-0.3h-4.464V9.31H133.85V19.934h3.872V11.262h1.408a0.3,0.3,0,0,1,.336.336v8.336h3.712Zm10.912,0V5.15h-3.712V9.87h-4.72a1.011,1.011,0,0,0-1.008,1.008v9.056h9.44Zm-5.728-8.528a0.3,0.3,0,0,1,.336-0.336h1.68v7.68h-2.016V11.406Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a095e0ffc83995a28592ea84ac8cded.svg";
export { ForwardRef as ReactComponent };